import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f134049a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 全部 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 未回复 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 已回复 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("回复")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  slot: "author",
  style: {"margin-left":"20px"}
}
const _hoisted_16 = {
  slot: "content",
  style: {"margin-left":"50px"}
}
const _hoisted_17 = { style: {"margin-left":"50px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { title: "反馈列表" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          style: {"width":"200px"},
          value: _ctx.searches.keywords,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
          placeholder: "请输入你想搜索的内容"
        }, null, 8, ["value"]),
        _createVNode(_component_a_select, {
          "default-value": "全部",
          style: {"width":"120px","margin-left":"10px"},
          placeholder: "状态",
          value: _ctx.searches.state,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.state) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: "" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "0" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "1" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_button, {
          onClick: _ctx.searchData,
          type: "primary",
          style: {"margin-left":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          onClick: _ctx.resetSearch,
          style: {"margin-left":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange,
      style: {"margin-top":"10px"}
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'nickname')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.user !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(record.user.nickname || ''), 1))
                : _createCommentVNode("", true),
              (record.user == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "未完善"))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'mobile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.user !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(record.user.mobile || ''), 1))
                : _createCommentVNode("", true),
              (record.user == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "未完善"))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'reply')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (record.state == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "未回复"))
                : _createCommentVNode("", true),
              (record.state == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(record.reply), 1))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.reply(record)),
                type: "primary",
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.getDetail(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "反馈详情",
      footer: null,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setVisible(undefined, false))),
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "反馈内容" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.content), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "反馈时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.create_date), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "反馈人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.nickname), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "图片" }, {
              default: _withCtx(() => [
                (_ctx.detail.images !== [])
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.detail.images, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("img", {
                          src: item,
                          style: {"max-width":"100px"}
                        }, null, 8, _hoisted_14)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_comment, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.reply_list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"margin-bottom":"30px"}
              }, [
                _createVNode(_component_a_avatar, {
                  slot: "avatar",
                  src: item.reply_user.avatar,
                  alt: "Han Solo"
                }, null, 8, ["src"]),
                _createElementVNode("a", _hoisted_15, _toDisplayString(item.reply_user.name), 1),
                _createElementVNode("p", _hoisted_16, _toDisplayString(item.reply), 1),
                _createVNode(_component_a_tooltip, { slot: "datetime" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.reply_date), 1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.replyVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.replyVisible) = $event)),
      title: "反馈详情",
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setVisible(undefined, false))),
      width: "30%",
      onOk: _ctx.replySubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          placeholder: "请输入内容",
          "allow-clear": "",
          value: _ctx.replymessage,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.replymessage) = $event)),
          type: "textarea",
          autosize: { minRows: 6, maxRows: 6 }
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}